import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";
import "./login.css";

const Login = () => {
  const [username, setUname] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (!username || !password) {
      setError("Please enter both username and password.");
      return;
    }

    try {
      const res = await api.post(
        "/api/login",          // ✅ SAME DOMAIN (cPanel-safe)
        {
          username,
          password
        }
      );

      // ✅ Backend response keys
      setSuccess(res.data.message);

      // ✅ Store JWT + username
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("username", res.data.username);

      // ✅ Redirect after login
      navigate("/searchdev", { replace: true });
    } catch (err) {
      console.error("Login error:", err);
      setError(err.response?.data?.message || "Login failed");
    }
  };

  return (
    <form className="login-container" onSubmit={handleSubmit}>
      <div className="login-form">
        <h2>Login</h2>
        {error && <p style={{ color: "red" }}>{error}</p>}
        {success && <p style={{ color: "green" }}>{success}</p>}

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUname(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Login</button>
      </div>
    </form>
  );
};

export default Login;